import {AbstractCrudApiService} from '@shared/abstracts/abstract-crud-api.service';
import { urlJoin } from '@shared/utils/url.utils';

export abstract class AbstractMemberService<Model, CreateDto, UpdateDto> extends AbstractCrudApiService<Model, CreateDto, UpdateDto> {

  override get endpoint(): string {
    return `${this.api$.value}/:memberId`;
  }

  protected constructor(
  ) {
    super();
    this.api$.next(urlJoin(this.env.get('api.base'), 'members'));
    this.logger.debug(this.name, 'Endpoint', this.endpoint);
  }
}
